export default __webpack_public_path__ + "static/media/product_3.3.f482f459.jpg";